import React, { Component } from "react";
import classnames from "classnames";
import {
    addMilliseconds,
    differenceInMilliseconds,
    startOfDay,
} from "date-fns";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { observeStore } from "../../stores";
import { formatDate } from "../../utils/formatDate";
import { DateEdit } from "../Observe/Timeline/DateEdit";
import { Button } from "./Button";
import * as styles from "./Clock.scss";
import { TimeEdit } from "./TimeEdit";
import { TimelineTimeEdit } from "./TimelineTimeEdit";

interface IClockProps {
    time: Date;
    maxTime?: Date | false;
    className?: string;
    dateClassName?: string;
    timeClassName?: string;
    onSelectTime?: (time: Date) => void;
    disabled?: boolean;
}

@observer
export class Clock extends Component<IClockProps> {
    @observable
    private editingDate: boolean = false;

    public render() {
        const {
            editingDate,
            onClickEditDate,
            onStopEditingDate,
            onDateChanged,
        } = this;
        const {
            time,
            maxTime,
            onSelectTime: onChangeTime,
            dateClassName,
            timeClassName,
            disabled,
        } = this.props;

        return (
            <div className={styles.clock}>
                <div
                    className={classnames(
                        styles.date,
                        editingDate && styles.editing,
                        dateClassName,
                    )}
                    onClick={onClickEditDate}
                >
                    <Button onClicked={onClickEditDate} disabled={disabled}>
                        {formatDate(time)}
                    </Button>
                </div>
                {!onChangeTime && (
                    <TimelineTimeEdit
                        className={classnames(styles.time, timeClassName)}
                        disabled={disabled}
                    />
                )}

                {onChangeTime && (
                    <TimeEdit
                        time={time}
                        className={classnames(styles.time, timeClassName)}
                        disabled={disabled}
                        onChangeTime={onChangeTime}
                    />
                )}

                {editingDate && (
                    <DateEdit
                        time={time}
                        maxTime={maxTime}
                        onDateChanged={onDateChanged}
                        onClose={onStopEditingDate}
                    />
                )}
            </div>
        );
    }

    private onClickEditDate = () => {
        this.editingDate = true;
    };

    private onStopEditingDate = () => {
        this.editingDate = false;
    };

    private onDateChanged = (date: Date) => {
        const { onSelectTime: onTimeChanged } = this.props;
        if (onTimeChanged) {
            onTimeChanged(
                addMilliseconds(
                    date,
                    differenceInMilliseconds(
                        this.props.time,
                        startOfDay(this.props.time),
                    ),
                ),
            );
        } else {
            const { time } = observeStore;
            observeStore.pauseAt(
                addMilliseconds(
                    date,
                    differenceInMilliseconds(time, startOfDay(time)),
                ),
            );
        }
    };
}
